/** Shared flex layout for landing spotlight cards (text + OrbitDeco). */
export function spotlightCardStyle(isMobile, { desktopPadding = "60px 48px", desktopGap = 60 } = {}) {
  return {
    padding: isMobile ? "40px 28px" : desktopPadding,
    display: "flex",
    alignItems: "center",
    gap: isMobile ? 32 : desktopGap,
    flexWrap: "wrap",
  };
}

/** Centers OrbitDeco when the card wraps on mobile. */
export function orbitDecoWrapStyle(isMobile, { scaleOnMobile = false } = {}) {
  const base = { flex: "0 0 auto" };
  if (!isMobile) return base;
  return {
    ...base,
    margin: "0 auto",
    ...(scaleOnMobile ? { transform: "scale(0.72)" } : {}),
  };
}
